import { TypographyProps } from "@mui/material";
import { LegalTypography } from "@covertree/ui";

export function LegalDisclaimer({ ...props }: TypographyProps) {
  return (
    <LegalTypography
      variant="subtitle1"
      sx={{
        ...props.sx,
      }}
      {...props}>
      CoverTree Inc. &#40;CoverTree&#41; is acting as the managing general agent
      of one or more non-affiliated underwriters in selling this insurance
      policy.
    </LegalTypography>
  );
}
